import React from 'react';
import { ModalConfirmacao } from 'components/Modais/ModalConfirmacao';
import { Button } from 'antd';

function BotaoCancelamento({ cancelarOperacao }) {

    return (
        <Button
            type="primary"
            danger onClick={
                () => ModalConfirmacao(
                    'Cancelar operação',
                    cancelarOperacao,
                    'Tem certeza que deseja cancelar a operação?'
                )
            }
        >
            Cancelar operação
        </Button>
    );
}

export default BotaoCancelamento;